import { render, staticRenderFns } from "./ButtonWithDropdown.vue?vue&type=template&id=596031ca&scoped=true&"
import script from "./ButtonWithDropdown.vue?vue&type=script&lang=ts&"
export * from "./ButtonWithDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonWithDropdown.vue?vue&type=style&index=0&id=596031ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596031ca",
  null
  
)

export default component.exports